import { createHelpers } from 'vuex-map-fields'
import { toLocalDate } from '@mixins/formattable'

const { getMemberManagementField } = createHelpers({
  getterType: 'getMemberManagementField'
})

export default {
  getMemberManagementField,
  memberDetailsQueryParams: state => state.memberDetailsQueryParams,
  memberDetails: state => state.memberDetails,
  memberUpdating: state => state.memberUpdating,
  memberDetailsLoading: state => state.memberDetailsLoading,
  memberAddresses: state => state.memberAddresses,
  memberAddressesLoading: state => state.memberAddressesLoading,
  memberLocked: state => {
    if (state.memberDetails && state.memberDetails.member) { return state.memberDetails.member.pendingEligibility } else return false
  },
  memberTransactions: state => {
    return state.memberTransactions.map(transaction => {
      transaction.memberName = `${transaction.memberFirstName} ${transaction.memberLastName}`
      transaction.statusDate = toLocalDate(transaction.statusDate)
      transaction.memberDateOfBirth = toLocalDate(transaction.memberDateOfBirth)
      return transaction
    })
  },
  memberTransactionsLoading: state => state.memberTransactionsLoading,
  memberEligibility: state => {
    if (state.memberDetails && state.memberDetails.member) { return state.memberDetails.member.eligibility } else return false
  },
  benefitCategories: state => {
    if (state.memberDetails && state.memberDetails.benefits) {
      return state.memberDetails
        .benefits
        .benefitDisplayCategories
        .sort((a, b) => {
          return a.displayOrder - b.displayOrder
        })
    } else return []
  },
  memberTransactionDrafts: state => state.memberTransactionDrafts,
  memberTransactionsErrorMessage: state => state.memberTransactionsErrorMessage,
  memberTransactionDetailsLoading: state => state.memberTransactionDetailsLoading,
  transactionSearch: state => state.transactionSearch,
}
